import React, { useEffect } from 'react';
import { IconButton, Paper, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/system';

const NotificationContainer = styled(Paper)(({ theme }) => ({
  position: 'fixed',
  top: 10,
  left: '50%',
  transform: 'translateX(-50%)',
  backgroundColor: 'rgba(255, 0, 0, 0.5)',
  border: '1px solid rgba(255, 0, 0, 0.8)',
  padding: theme.spacing(1, 2),
  display: 'flex',
  alignItems: 'center',
  zIndex: 1000,
  width: '100%',
  maxWidth: '500px',
}));

const Title = styled(Typography)(({ theme }) => ({
  color: '#fff',
  fontWeight: 'bold',
  marginRight: theme.spacing(1),
}));

const Message = styled(Typography)(({ theme }) => ({
  color: '#fff',
}));

const Notification = ({ title, message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 5000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <NotificationContainer elevation={3}>
      <Title variant="subtitle1">{title}:</Title>
      <Message variant="body2">{message}</Message>
      <IconButton
        color="inherit"
        onClick={onClose}
        style={{ marginLeft: 'auto' }}
      >
        <CloseIcon style={{ color: '#fff' }} />
      </IconButton>
    </NotificationContainer>
  );
};

export default Notification;
